import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeaderPage from '../../components/HeaderPage';
import { toast } from 'react-hot-toast';
import axiosInstance from '../../../axiosInstance';
import getDecryptData from '../../../helper/getDecryptData';
import LoadingScreen from '../../components/LoadingScreen';

const AccountPassword = () => {
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [formData, setFormData] = useState({ password: '', password2: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const submitData = async () => {
    const decryptdatajson = await getDecryptData();
    const id = decryptdatajson?._id;

    if (formData.password !== formData.password2) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setSubmitLoading(true);
      if (id) {
        await axiosInstance.put(`/update-profile/${id}`, formData);
        toast.success("Password Updated!");
        setFormData({ password: '', password2: '' });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <Header />
      <HeaderPage title="Change Password" />

      <main className="page-content bg-light py-5">
        <div className="container">
          {!loading ? (
            <LoadingScreen />
          ) : (
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-8">
                <div className="card shadow-sm border-0 p-4 hover-scale">
                  <div className="text-center mb-4">
                    <i className="fas fa-lock fa-3x text-primary"></i>
                    <h4 className="mt-3">Update Password</h4>
                    <p className="text-muted">Keep your account secure</p>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter new password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm new password"
                      name="password2"
                      value={formData.password2}
                      onChange={handleChange}
                    />
                  </div>

                  <button
                    className="btn btn-primary w-100"
                    onClick={submitData}
                    disabled={submitLoading}
                  >
                    {submitLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Updating...
                      </>
                    ) : (
                      "Update Password"
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>

      <Footer />

      {/* Custom Styles */}
      <style>
        {`
          .hover-scale {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .hover-scale:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 25px rgba(0,0,0,0.15);
          }
        `}
      </style>
    </>
  );
};

export default AccountPassword;
